export default __webpack_public_path__ + "static/media/Screenshot (1170).e8df5d15.png";